import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from '../../Home/register/register';

@Component({
  selector: 'app-crm-hero',
  standalone: true,
  imports: [CommonModule, RegisterComponent],
  templateUrl: './crm-hero.html',
  styleUrls: ['./crm-hero.css'],
})
export class CrmHeroComponent {
  showRegister = false;
  crmApp = [{ name: 'CRM', image: 'images/webps/crm.svg' }];
}
